import { Breadcrumb, Layout } from 'antd';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { LeftSiderBarWith } from '../../../../constants/constants';
import { ROUTE_PATHS } from '../../../../constants/url-config';
import { BreadcrumbModel } from "../../../../models/breadcrumb.model";
import { setIsLogined, setUserInfoToAppState } from '../../../../redux/actions/user.action';
import { AppState } from '../../../../redux/store';
import { AuthService } from '../../../../services/auth.service';
import AppAvatar from '../../../atoms/avatar';
import { ChevronRight } from "../../../atoms/icon";
import AppSiderBar from '../../../atoms/sider-bar';
import "./main.scss";
import LanguagePicker from '../../../../lang/shared/LanguagePicker';
const { Header, Content } = Layout;

const MainLayout = ({ children }: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const headerState = useSelector((state: AppState) => state.headerState);
  const userState = useSelector((state: AppState) => state.userState);


  const logout = () => {
    AuthService.logout();
    dispatch(setIsLogined(false));
    history.push(ROUTE_PATHS.SignIn);
  }

  const breadcrumbItemClick = (item: BreadcrumbModel) => {
    if (item.href !== undefined) {
      history.push(item.href);
    }
  }

  useEffect(() => {
    dispatch(setUserInfoToAppState());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout>
      <AppSiderBar logout={logout} />

      <Layout className={`site-layout ${headerState.hideBreadcrumb ? "" : " has-breadcrumb"}`} style={{ marginLeft: LeftSiderBarWith }}>
        <div className="header-wrapper" style={{ width: `calc(100% - ${LeftSiderBarWith}px)` }}>
          <Header className="site-layout-header">
            <div className="title">{headerState.title} {headerState.status}</div>
            <div style={{display:"flex", alignItems:"end", gap: "4px"}}>
              <LanguagePicker />
              <AppAvatar name={userState.user?.username} />
            </div>
          </Header>
          {
            !headerState.hideBreadcrumb &&
            <Header className="site-layout-header breadcrumb-wapper">
              <div className='left-box'>
                {headerState.breadcrumbs &&
                  <Breadcrumb separator={<ChevronRight />} className="breadcrumb">
                    {headerState.breadcrumbs.map((item, index) => (
                      <Breadcrumb.Item onClick={() => breadcrumbItemClick(item)} key={index}>{item.title}</Breadcrumb.Item>
                    ))}
                  </Breadcrumb>
                }

              </div>

              <div className='right-box'>
                {headerState.actions}
              </div>

            </Header>
          }
        </div>

        <Content className='main-content'>
          {children}
        </Content>
      </Layout>
    </Layout>

  );
};

export default MainLayout;

